// Reads the palette _charts.scss publishes as custom properties from the tokens, once per colour
const DONUT_COUNT  : number = 5;
const SERIES_COUNT : number = 5;

export const DONUT_COLOR_COUNT : number = DONUT_COUNT;

const cache : Map<string, string> = new Map<string, string>();

// series colour by position: neutral for prior and other, brand greens, then the categorical blues
export function chartColor ( index : number ) : string {
  return readColor(`--chart-series-${ ( index % SERIES_COUNT ) + 1 }`);
}

// a label keeps its colour across renders when it sits in the known option list
export function donutColor ( label : string, options : Array<string>, fallbackIndex : number ) : string {
  const optionIndex = options ? options.indexOf(label) : -1;

  return donutSegmentColor(optionIndex >= 0 ? optionIndex : fallbackIndex);
}

export function donutOtherColor () : string {
  return readColor('--chart-other');
}

export function donutSegmentColor ( index : number ) : string {
  return readColor(`--chart-donut-${ ( index % DONUT_COUNT ) + 1 }`);
}

// an empty read means the stylesheet is not in the document yet, so nothing is cached
function readColor ( name : string ) : string {
  if ( !cache.has(name) ) {
    const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();

    if ( !value ) {
      return value;
    }

    cache.set(name, value);
  }

  return cache.get(name);
}
